import { createSlice, PayloadAction } from 'ngrx-slice';

import { SiteSelectItemDto } from '@app/api/models';

export interface State {
  standalonePackagingUnits: Array<SiteSelectItemDto>;
  collectionPackagingUnits: Array<SiteSelectItemDto>;
}

export const initialState: State = {
  standalonePackagingUnits: [],
  collectionPackagingUnits: [],
};

export const {
  actions: ProductPackagingUnitActions,
  selectors,
  ...ProductPackagingUnitFeature
} = createSlice({
  name: 'product-packaging-unit',
  initialState,
  reducers: {
    loadStandalonePackagingUnits: {
      trigger: (
        state,
        _action: PayloadAction<{
          withDepositFee: boolean;
          packingMethodSubType: string;
        }>
      ) => {
        state.standalonePackagingUnits = [];
      },
      success: (
        state,
        action: PayloadAction<{
          packagingUnits: Array<SiteSelectItemDto>;
        }>
      ) => {
        state.standalonePackagingUnits = action.packagingUnits;
      },
    },
    loadCollectionPackagingUnits: {
      trigger: (
        state,
        _action: PayloadAction<{
          withDepositFee: boolean;
          packingMethodSubType: string;
        }>
      ) => {
        state.collectionPackagingUnits = [];
      },
      success: (
        state,
        action: PayloadAction<{
          packagingUnits: Array<SiteSelectItemDto>;
        }>
      ) => {
        state.collectionPackagingUnits = action.packagingUnits;
      },
    },
    reset: (_) => initialState,
  },
});

export const ProductPackagingUnitSelectors = {
  ...selectors,
};
